import f from "../../funcs";

import Api from "./Api";
import Filter from "./filter/Filter";
import Filter3 from "../storage/filter3/Filter3";


// helpers:
function setFiltersInRequestData(request, params) {
    const { data } = request || {};
    const { filter, filter3 } = params || {};

    if ( !data ) {
        return;
    }

    const requestFilter = getRequestFilter(filter, filter3);
    if ( !requestFilter ) {
        return;
    }

    if ( requestFilter.noRows ) {
        data.filters = {
            tryNewFilterFormat: true,
            value: [ ["ID", "=", 1], "and", ["ID", "<>", 1] ]
        };
    } else if ( !requestFilter.isEmpty() ) {
        data.filters = {
            tryNewFilterFormat: true,
            value: requestFilter.toJSON()
        };
    }
}

function getRequestFilter(filter, filter3) {
    const convertedFilter = filterToFilter3(filter);
    const convertedFilter3 = filter3ToFilter3(filter3);

    if ( convertedFilter3 && convertedFilter ) {
        return convertedFilter3.and(convertedFilter);
    }

    if ( convertedFilter3 ) {
        return convertedFilter3;
    }

    return convertedFilter;
}

function filterToFilter3(filter) {
    if ( !filter ) {
        return;
    }

    if ( filter instanceof Filter3 ) {
        return filter;
    }

    if ( filter instanceof Filter ) {
        return new Filter3(filter, true);
    }

    return new Filter3(new Filter(filter), true);
}

function filter3ToFilter3(filter3) {
    if ( !filter3 ) {
        return;
    }

    if ( filter3 instanceof Filter3 ) {
        return filter3;
    }

    return new Filter3(filter3);
}

function _fixSortGroupBy(request, params) {
    params = params || {};
    // сервер не включает поля указанные в sort, в группировку
    // также вставляем сортировку по id, по возростанию
    // НО, в запросе distinct не должно быть сортировки
    if ( !request.data.distinct && !f.isArray(request.data.sort) ) {
        request.data.sort = [{ ID: 1 }];
    }

    if ( !request.data.distinct && f.isArray(request.data.sort) ) {
        if ( !request.data.distinct && !request.data.sort.some(function(sort) {
            return sort.ID;
        }) ) {
            if ( params.sortById !== false ) {
                request.data.sort.push({ ID: 1 });
            }
        }
        request.data.viewedFields = request.data.viewedFields.concat(request.data.sort.map(function(sort) {
            // ???
            for (let key in sort) {
                return key;
            }
        }));
    }
    request.data.viewedFields = f.removeRepeat(request.data.viewedFields);
}

let fakeId = 0;

function normolizeId(row) {
    let id = f.getId(row);
    if ( !id && id !== 0 ) {
        id = "f" + (++fakeId);
    }

    f.setId(row, id);

    return row;
}

function normolizeColors(row) {
    if ( !row.COLORS ) {
        row.COLORS = {};
    } else if ( f.isString(row.COLORS) ) {
        try {
            row.COLORS = JSON.parse(row.COLORS);
        } catch (e) {
            row.COLORS = {};
        }
    }
    return row;
}

//
// НЕ ВЕДИСЬ НА !!DRY!!
// c DRY нельзя поставить breakpoint в devTools на конкретном методе!!

/**
     * TableApi класс для работы с таблицами на сервере
     * @constructs TableApi
     * @extends Api
     * @param {String} name Имя таблицы, с которой хотим работать
     *
     * @example <caption>Filters2.0 - объект вида:  </caption>
     * var company = new TableApi("LIST_COMPANY");
     * company.getCount(function(err, count) {
     *   console.log("В таблице LIST_COMPANY "+ count + " строк");
     * });
     */
const TableApi = Api.extend("TableApi", {
    _entity: "table",

    init(name) {
        this.name = name;
        this.currentFilterVersion = "2.9";
        //this.processRow @see RowsStorage
    },

    /**
     * Получить одну запись из таблицы по ее id или
     * получить массив записей из таблицы по параметрам
     * @param  {Number | String | Object}  params idOrParams
     * Если idOrParams это id строки то в callback придет один объект
     * Если idOrParams то смотри пример ниже
     * @example <caption>typical get params</caption>
     * {
     *   offset: {Number}
     *   limit: {Number}
     *   search: {String} строка для поиска по всем столбцам в таблице
     *   регистронезависимый поиск по содержимому
     *
     *   filter: {Filter} @see classes/api/filter/Filter
     *   sort: {Array} массив объектов, где каждый объект должен быть в виде
     *   {
     *     {COLUMN_KEY}: {SORT_VECTOR}
     *   }
     *   columns: {Array | String} массив строк, ключей
     *      если columns === "all", то будут выбраны все доступные колонки в таблице
     * }
     * @param  {Function} callback
     * callback(err, row)  когда поиск по id
     * callback(err, rows)  когда поиск по параметрам
     */
    async get(params, callback) {
        if ( params.noRows ) {
            if ( callback ) {
                return setTimeout(() => {
                    callback(null, []);
                });
            } else {
                return Promise.resolve([]);
            }
        }

        let request = {
            entity: "table",
            method: "get",
            target: this.name,
            data: TableApi.makeGetRequestData(params)
        };

        request.headers = f.deepMixin(request.headers, {
            "TableApi2-method": "get"
        });

        _fixSortGroupBy(request, params);
        if ( params.distinct ) {
            if ( params.distinct === "ID" ) {
                request.data.viewedFields = [
                    "ID"
                ];
            }
            else {
                request.data.viewedFields = [
                    "ID",
                    params.distinct
                ];
            }
        }

        let result;
        let err;
        try {
            result = await Api.request(request);
        } catch (_err) {
            err = _err;
        }

        if ( err ) {
            if ( callback ) {
                callback(err, []);
                return;
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }

        const keys = request.data.viewedFields;
        let rows = result.rows.map((row) => {
            if ( Array.isArray(row) ) {
                const values = row;
                row = {};
                for (let i = 0, n = keys.length; i < n; i++) {
                    const key = keys[ i ];
                    const value = values[ i ];
                    row[ key ] = value;
                }
            }

            normolizeId(row);
            normolizeColors(row);
            return row;
        });

        let hasId = {};
        let errorIds = {};
        rows.forEach(function(row) {
            let id = f.getId(row);
            if ( hasId[id] ) {
                errorIds[ id ] = true;
            }
            hasId[id] = true;
        });

        errorIds = Object.keys(errorIds);
        if ( errorIds.length ) {
            console.error("duplicate ids (" + errorIds.join(",") + ") in entity: " + this.name);
        }

        if ( this.processRow && rows ) {
            rows = rows.map(this.processRow, this);
        }

        if ( callback ) {
            callback(err, rows);
        } else {
            return rows;
        }
    },

    /**
         * Создание строки в таблице. На входе передаем данные для новой строки,
         * на выходе получаем строку со всеми ее полями и id
         * @param  {Object}   data     данные строки, необязательный аргумент
         * @param  {Function}   callback
         * callback(err, row)
         */
    async create(data, callback) {
        if ( f.isFunction(data) ) {
            callback = data;
            data = {};
        }

        let result;
        let err;
        try {
            result = await Api.request({
                entity: "table",
                method: "create",
                target: this.name,
                data
            });
        } catch (_err) {
            err = _err;
        }

        if ( err ) {
            if ( callback ) {
                callback(err, null);
                return;
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }

        let rows = result.rows.map((item) => {
            let row = { _id: null };

            if ( item ) {
                row = item;
                normolizeId(row);
                if ( this.processRow ) {
                    row = this.processRow(row);
                }
            }

            return row;
        });

        if ( callback ) {
            callback(err, rows);
        } else {
            return rows;
        }
    },

    /**
         * Изменение данных строки, на входе данные, которые слудет изменить и id строки,
         * которую нужно изменить
         * @param  {Number | String}   id       идентификатор строки
         * @param  {Object}   changes  Объект с данными на изменение,
         * содержит только те данные, которые нужно изменить
         * @param  {Function} callback
         * callback(err, row)
         * на выходе имеем строку целиком, со всеми ее полями
         */
    async update(id, changes, callback) {
        changes = f.deepClone(changes);

        let result;
        let err;
        try {
            result = await Api.request({
                entity: "table",
                method: "update2",
                target: this.name,
                data: {
                    id,
                    changes
                }
            });
        } catch (_err) {
            err = _err;
        }

        let row;
        if ( !err && result && result.row ) {
            row = f.deepClone(result.row);
            normolizeId(row);
            if ( this.processRow ) {
                row = this.processRow(row);
            }
        }

        if (
            row
                && Object.keys(changes).length == 1
                && changes.COLORS
        ) {
            row.COLORS = f.deepClone(changes.COLORS);
        }

        if ( err ) {
            if ( callback ) {
                callback(err, row);
                return;
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }

        if ( callback ) {
            callback(err, row);
        } else {
            return row;
        }
    },

    /**
         * Перенос строк в корзину (set DELETED: 1)
         * на входе массив id или один id
         * @param  {Array | Number | String}   id       идентификатор или их список
         * @param  {Function} callback
         * callback(err, status)
         * status: {Boolean}
         */
    async trash(id, callback) {
        let ids = [id];
        if ( f.isArray(id) ) {
            ids = id;
        }

        if ( !ids.length ) {
            if ( callback ) {
                return setTimeout(() => {
                    callback(null, true);
                });
            } else {
                return Promise.resolve(true);
            }
        }

        let result;
        let err;
        try {
            await Api.request({
                entity: "table",
                method: "trash",
                target: this.name,
                data: ids
            });
        } catch (_err) {
            err = _err;
        }

        if ( err ) {
            if ( callback ) {
                callback(err, []);
                return;
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }

        result = result && result.status == "success";

        if ( callback ) {
            callback(err, result);
        } else {
            return result;
        }
    },

    /**
         * Перенос строк ИЗ корзину (set DELETED: 0)
         * на входе массив id или один id
         * @param  {Array | Number | String}   id       идентификатор или их список
         * @param  {Function} callback
         * callback(err, status)
         * status: {Boolean}
         */
    async untrash(id, callback) {
        let ids = [id];
        if ( f.isArray(id) ) {
            ids = id;
        }

        let result;
        let err;
        try {
            result = await Api.request({
                entity: "table",
                method: "untrash",
                target: this.name,
                data: ids
            });
        } catch (_err) {
            err = _err;
        }

        if ( err ) {
            if ( callback ) {
                callback(err, []);
                return;
            } else {
                // redefine callStack
                let redefinedError = new Error( err.message );
                redefinedError.original = err;
                throw redefinedError;
            }
        }

        result = result && result.status == "success";

        if ( callback ) {
            callback(err, result);
        } else {
            return result;
        }
    },

    /**
         * БЕЗВОЗВРАТНОЕ удаление строк
         * на входе массив id или один id
         * @param  {Array | Number | String}   id       идентификатор или их список
         * @param  {Function} callback
         * callback(err, status)
         * status: {Boolean}
         */
    async remove(id, callback) {
        let ids = [id];
        if ( f.isArray(id) ) {
            ids = id;
        }

        let result;
        let err;
        try {
            result = await Api.request({
                entity: "table",
                method: "remove",
                target: this.name,
                data: ids
            });
        } catch (_err) {
            err = _err;
        }

        if ( err ) {
            if ( callback ) {
                callback(err, []);
                return;
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }

        result = result && result.status == "success";

        if ( callback ) {
            callback(err, result);
        } else {
            return result;
        }
    },

    /**
         * Узнаем индекс одной строки в таблице.
         * Существуют задачи, где курсор в таблице должен быть на одном месте,
         * независимо от сортировок или фильтров.
         * На входе имеем либо id, либо объект с .get параметрами и id
         * @param  {Object}   row       Идентификатор строки или объект с ним, смотри пример
         * @param  {Function} callback
         * callback(err, index)
         * @example <caption>Индекс строки в таблице с фильтрами</caption>
         * // someFilter: classes/api/filter/Filter
         * var company = new TableApi("LIST_COMPANY");
         * company.indexOf({
         *   row: {ID: 1003},
         *   filter: someFilter,
         *   sort: [{ID: -1}]
         * }, function(err, index) {
         *   // index либо -1 либо число от 0 до бесконечности
         *   console.log(index);
         * })
         */
    async indexOf(params, callback) {
        let request = {
            entity: "table",
            method: "get",
            target: this.name,
            data: {
                viewedFields: ["ID"],
                offset: 0,
                limit: 1,
                skipTo: params.row
            }
        };

        setFiltersInRequestData(request, params);

        if ( params.search ) {
            request.data.search = params.search;
        }

        // влияет на group by, который влияет на сортировку строк
        if ( f.isArray(params.columns) ) {
            request.data.viewedFields = params.columns;
        }

        if ( f.isArray(params.sort) ) {
            request.data.sort = params.sort;
        }

        _fixSortGroupBy(request);

        request.headers = f.deepMixin(request.headers, {
            "TableApi2-method": "indexOf"
        });

        let result;
        let err;
        try {
            result = await Api.request(request);
        } catch (_err) {
            err = _err;
        }

        if ( err ) {
            if ( callback ) {
                callback(err, -1);
                return;
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }

        // сервер может прислать ничего или пустой масив
        let rows = result.rows || [];
        let numb = +(rows[0] || [])[0];

        if ( !f.isNumber(numb) || numb === 0 ) {
            numb = -1;
        } else {
            numb--;
        }

        if ( callback ) {
            callback(err, numb);
        } else {
            return numb;
        }
    },

    /**
         * Узнаем кол-во строк в таблице
         * @param  {Object}   params   необязательный аргумент,
         * объект типичных .get параметров
         * @param  {Function} callback
         * callback(err, count)
         * count - целое число от 0 и выше
         * @example <caption> getCount example </caption>
         * var banks = new TableApi("LIST_BANKS");
         *
         * banks.getCount(function(err, count) {
         *   console.log("В таблице банков всего "+ count +" строк");
         * });
         *
         * banks.getCount({
         *   search: "Ушаков",
         *   columns: ["LIST_BANKS_NAME"]
         * }, function(err, count) {
         *   console.log("Кол-во банков, которые содержат слово Ушаков водном из своих полей: " + count);
         * })
         *
         */
    async getCount(params, callback) {
        if ( f.isFunction(params) ) {
            callback = params;
            params = {};
        }
        params = params || {};

        let request = {
            entity: "table",
            method: "get",
            target: this.name,
            data: {
                viewedFields: ["ID"],
                offset: 0,
                limit: 1,
                getCount: 1
            }
        };

        if ( f.isArray(params.excludeFromSearch) && params.excludeFromSearch.length ) {
            request.data.excludeFromSearch = params.excludeFromSearch;
        }

        if ( params.noRows ) {
            if ( callback ) {
                setTimeout(() => {
                    callback(null, 0);
                }, 0);
                return;
            } else {
                return Promise.resolve(0);
            }
        }

        setFiltersInRequestData(request, params);

        if ( params.search ) {
            request.data.search = params.search;
            request.data.viewedFields = params.columns;
        }

        _fixSortGroupBy(request);

        if ( params.distinct ) {
            request.data.groupBy = [params.distinct];
            request.data.viewedFields = [params.distinct];
        }

        request.headers = f.deepMixin(request.headers, {
            "TableApi2-method": "getCount"
        });

        if ( params.DELETED === 1 ) {
            request.data.DELETED = 1;
        }

        if ( f.isObject(params.scope) ) {
            request.data.scope = params.scope;
        }

        let result;
        let err;
        try {
            result = await Api.request(request);
        } catch (_err) {
            err = _err;
        }

        let count = 0;
        if ( err ) {
            if ( callback ) {
                callback(err, 0);
                return;
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }

        if ( f.isNumber(+result.count) && +result.count >= 0 ) {
            count = +result.count;
        } else {
            //console.error("bad count", result.count);
        }

        if ( callback ) {
            callback(err, count);
        } else {
            return count;
        }
    },

    async lock(id, callback) {
        let result;
        let err;
        try {
            result = await Api.request({
                entity: "table",
                method: "lock",
                target: this.name,
                data: {
                    rowId: id
                }
            });
        } catch (_err) {
            err = _err;
        }

        if ( !result ) {
            err = { state: true, err, message: "null_result_in_lock" };
        }

        if ( err ) {
            if ( callback ) {
                callback(err, null);
                return;
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }

        let locked = (
            result.locked
                && result.lockedBy != system.user.id
        );

        result = {
            state: locked,
            lockedBy: result.lockedBy
        };

        if ( callback ) {
            callback(err, result);
        } else {
            return result;
        }
    },

    async unlock(id, callback) {
        let result;
        let err;
        try {
            result = await Api.request({
                entity: "table",
                method: "unlock",
                target: this.name,
                data: {
                    rowId: id
                }
            });
        } catch (_err) {
            err = _err;
        }

        if ( !result ) {
            err = { state: true, err, message: "null_result_in_unlock" };
        }

        if ( err ) {
            if ( callback ) {
                callback(err, null);
                return;
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }

        let locked = (
            result.locked
                && result.lockedBy != system.user.id
        );

        result = {
            state: locked,
            lockedBy: result.lockedBy
        };

        if ( callback ) {
            callback(err, result);
        } else {
            return result;
        }
    },

    async getTabs(callback) {
        let result;
        let err;
        try {
            result = await Api.request({
                entity: "table",
                method: "getTabs",
                target: this.name
            });
        } catch (_err) {
            err = _err;
        }

        if ( err ) {
            if ( callback ) {
                callback(err, []);
                return;
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }

        let tabs;
        if ( result && result.tabs ) {
            // фиксим:
            // нет активной влкадки или их две
            let hasActive = false;
            result.tabs.some((tab) => {
                if ( tab.is_active ) {
                    if ( hasActive ) {
                        tab.is_active = false;
                    }
                    hasActive = true;
                }
            });

            if ( !hasActive && result.tabs.length ) {
                result.tabs[0].is_active = true;
            }

            tabs = result.tabs;
        }

        if ( callback ) {
            await callback(err, tabs);
        } else {
            return tabs;
        }
    },

    async removeTab(tabId, callback) {
        let result;
        let err;
        try {
            result = await Api.request({
                entity: "table",
                method: "removeTab",
                target: this.name,
                data: {
                    tabId
                }
            });
        } catch (_err) {
            err = _err;
        }

        if ( err ) {
            if ( callback ) {
                callback(err, []);
                return;
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }

        result = result && result.tabs;

        if ( callback ) {
            callback(err, result);
        } else {
            return result;
        }
    },

    async changeActiveTab(newId, oldId, callback) {
        try {
            await Api.request({
                entity: "table",
                method: "changeActiveTab",
                target: this.name,
                data: {
                    newId,
                    oldId
                }
            });
            if ( callback ) callback();
        } catch (err) {
            if ( callback ) {
                callback(err);
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }
    },

    async createTab(data, callback) {
        // нуемаё!!
        if ( data && data.fields_width && !data.fields ) {
            data.fields = data.fields_width;
        }

        let result;
        let err;
        try {
            result = await Api.request({
                entity: "table",
                method: "createTab",
                target: this.name,
                data
            });
        } catch (_err) {
            err = _err;
        }

        if ( err ) {
            if ( callback ) {
                callback(err, []);
                return;
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }

        let tab = result && result.tab || result;

        if ( callback ) {
            callback(err, tab);
        } else {
            return tab;
        }
    },

    async updateTab(id, data, callback) {
        data = f.deepClone(data);
        delete data.sort;
        delete data.id;
        delete data.ID;
        delete data._id;
        delete data._id;
        delete data.tab_title;
        delete data.viewed_fields;
        delete data.is_default;
        delete data.tab_title_lang;
        data.tabId = id;

        try {
            await Api.request({
                entity: "table",
                method: "updateTab",
                target: this.name,
                data
            });
        } catch (err) {
            if ( callback ) {
                callback(err);
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }
    },

    async getUniqueDays(params, callback) {
        if ( f.isFunction(params) ) {
            callback = params;
            params = {};
        }

        // sort: [{ID: 1}, {NAME: -1}]
        let sort = params.sort;
        let request = {
            entity: "table",
            method: "getUniqueDays",
            target: this.name,
            data: {
                field: params.field,
                viewedFields: f.removeRepeat([ "ID", "DT_CREATE", params.field ])
            }
        };

        if ( params.DELETED === 1 ) {
            request.data.DELETED = 1;
        }

        if ( f.isObject(params.scope) ) {
            request.data.scope = params.scope;
        }

        if ( params.noRows ) {
            if ( callback ) {
                return setTimeout(() => {
                    callback(null, []);
                });
            } else {
                return Promise.resolve([]);
            }
        }

        setFiltersInRequestData(request, params);

        if ( params.search ) {
            request.data.search = params.search;
        }

        if ( sort ) {
            request.data.sort = sort;
        }

        request.headers = f.deepMixin(request.headers, {
            "TableApi2-method": "getUniqueDays"
        });

        let result;
        let err;
        try {
            result = await Api.request(request);
        } catch (_err) {
            err = _err;
        }

        if ( err ) {
            if ( callback ) {
                callback(err, []);
                return;
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }

        let days = [];
        if ( f.isObject(result) && f.isArray(result.days) ) {
            days = result.days;
        }

        days = days.map((day) =>
            f.timestamp2userdate(f.parseDate(day && day[params.field]).date)
        );

        days = days.filter((day) =>
            day && f.isString(day)
        );

        if ( callback ) {
            callback(err, days);
        } else {
            return days;
        }
    },

    async export(params, callback) {
        params = f.deepClone(params);

        let columns = {};
        params.columns = params.columns.map((column) => {
            columns[column.key] = column;
            return column.key;
        });

        let request = {
            entity: "table",
            method: "export",
            target: this.name,
            data: TableApi.makeGetRequestData(params)
        };

        let viewedFields = [];
        request.data.viewedFields.forEach((key) => {
            let column = columns[key];
            if ( column ) {
                viewedFields.push(column);
            }
        });
        request.data.viewedFields = viewedFields;

        let result;
        let err;
        try {
            result = await Api.request(request);
        } catch (_err) {
            err = _err;
        }

        if ( err ) {
            if ( callback ) {
                callback(err, []);
                return;
            } else {
                // redefine callStack
                throw new Error(err.message);
            }
        }

        if ( callback ) {
            callback(err, result);
        } else {
            return result;
        }
    }
});

TableApi.makeGetRequestData = function(params) {
    params = f.deepClone(params);

    // sort: [{ID: 1}, {NAME: -1}]
    let sort = params.sort;
    // columns: { ["NAME", "INN", "DESCRIPTION"] | "all" }
    let columns = f.deepClone(params.columns || "all");
    let offset = params.offset || 0;
    // limit: {number | "all"}
    let limit = params.limit || "all";

    let request = {
        data: {
            viewedFields: columns,
            offset,
            limit
        }
    };

    if ( params.DELETED === 1 ) {
        request.data.DELETED = 1;
    }

    if ( f.isObject(params.scope) ) {
        request.data.scope = params.scope;
    }

    setFiltersInRequestData(request, params);

    if ( params.search ) {
        request.data.search = params.search;
        if ( f.isArray(params.excludeFromSearch) && params.excludeFromSearch.length ) {
            request.data.excludeFromSearch = params.excludeFromSearch;
        }
    }

    // если не передавать ID в viewedFields, то сервер вернет строки без ID
    if ( f.isArray(columns) && columns.indexOf("ID") === -1 ) {
        columns.push("ID");
    }
    if ( params.colors && f.isArray(columns) && columns.indexOf("COLORS") === -1 ) {
        columns.push("COLORS");
    }
    if ( params.createFields && f.isArray(columns) && columns.indexOf("DT_CREATE") === -1 ) {
        columns.push("DT_CREATE");
    }
    if ( params.createFields && f.isArray(columns) && columns.indexOf("DT_UPDATE") === -1 ) {
        columns.push("DT_UPDATE");
    }

    if ( sort ) {
        request.data.sort = sort;
    }

    if ( params.distinct ) {
        request.data.groupBy = [params.distinct];
        request.data.viewedFields = [params.distinct];
    }

    // сервер ждет, что columns это всегда массив ключей
    // на клиенте бывает удобно получать строки со всеми столбцами
    // поэтому разбиваем текущий запрос на 2 части
    // ЗЫ если есть желани переписать на промисы, то дерзай =)

    if ( columns == "all" ) {
        throw new Error("set columns in request or use RowsStorage!");
    } else {
        request.data.viewedFields = f.removeRepeat(request.data.viewedFields);
    }

    return request.data;
};

export default TableApi;
